<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      d="M5.33333 3.33317C4.96514 3.33317 4.66667 3.63165 4.66667 3.99984C4.66667 4.36803 4.96514 4.6665 5.33333 4.6665H5.34C5.70819 4.6665 6.00667 4.36803 6.00667 3.99984C6.00667 3.63165 5.70819 3.33317 5.34 3.33317H5.33333Z"
    />
    <path
      d="M10 3.99984C10 3.63165 10.2985 3.33317 10.6667 3.33317H10.6733C11.0415 3.33317 11.34 3.63165 11.34 3.99984C11.34 4.36803 11.0415 4.6665 10.6733 4.6665H10.6667C10.2985 4.6665 10 4.36803 10 3.99984Z"
    />
    <path
      d="M8 3.33317C7.63181 3.33317 7.33333 3.63165 7.33333 3.99984C7.33333 4.36803 7.63181 4.6665 8 4.6665H8.00667C8.37486 4.6665 8.67333 4.36803 8.67333 3.99984C8.67333 3.63165 8.37486 3.33317 8.00667 3.33317H8Z"
    />
    <path
      d="M7.33333 6.6665C7.33333 6.29831 7.63181 5.99984 8 5.99984H8.00667C8.37486 5.99984 8.67333 6.29831 8.67333 6.6665C8.67333 7.03469 8.37486 7.33317 8.00667 7.33317H8C7.63181 7.33317 7.33333 7.03469 7.33333 6.6665Z"
    />
    <path
      d="M8 8.6665C7.63181 8.6665 7.33333 8.96498 7.33333 9.33317C7.33333 9.70136 7.63181 9.99984 8 9.99984H8.00667C8.37486 9.99984 8.67333 9.70136 8.67333 9.33317C8.67333 8.96498 8.37486 8.6665 8.00667 8.6665H8Z"
    />
    <path
      d="M10 6.6665C10 6.29831 10.2985 5.99984 10.6667 5.99984H10.6733C11.0415 5.99984 11.34 6.29831 11.34 6.6665C11.34 7.03469 11.0415 7.33317 10.6733 7.33317H10.6667C10.2985 7.33317 10 7.03469 10 6.6665Z"
    />
    <path
      d="M10.6667 8.6665C10.2985 8.6665 10 8.96498 10 9.33317C10 9.70136 10.2985 9.99984 10.6667 9.99984H10.6733C11.0415 9.99984 11.34 9.70136 11.34 9.33317C11.34 8.96498 11.0415 8.6665 10.6733 8.6665H10.6667Z"
    />
    <path
      d="M4.66667 6.6665C4.66667 6.29831 4.96514 5.99984 5.33333 5.99984H5.34C5.70819 5.99984 6.00667 6.29831 6.00667 6.6665C6.00667 7.03469 5.70819 7.33317 5.34 7.33317H5.33333C4.96514 7.33317 4.66667 7.03469 4.66667 6.6665Z"
    />
    <path
      d="M5.33333 8.6665C4.96514 8.6665 4.66667 8.96498 4.66667 9.33317C4.66667 9.70136 4.96514 9.99984 5.33333 9.99984H5.34C5.70819 9.99984 6.00667 9.70136 6.00667 9.33317C6.00667 8.96498 5.70819 8.6665 5.34 8.6665H5.33333Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 15.3332H4C2.89543 15.3332 2 14.4377 2 13.3332V2.6665C2 1.56193 2.89543 0.666504 4 0.666504H12C13.1046 0.666504 14 1.56193 14 2.6665V13.3332C14 14.4377 13.1046 15.3332 12 15.3332ZM4 1.99984C3.63181 1.99984 3.33333 2.29831 3.33333 2.6665V13.3332C3.33333 13.7014 3.63181 13.9998 4 13.9998H5.33333V11.9998C5.33333 11.6316 5.63181 11.3332 6 11.3332H10C10.3682 11.3332 10.6667 11.6316 10.6667 11.9998V13.9998H12C12.3682 13.9998 12.6667 13.7014 12.6667 13.3332V2.6665C12.6667 2.29831 12.3682 1.99984 12 1.99984H4ZM9.33333 13.9998V12.6665H6.66667V13.9998H9.33333Z"
    />
  </svg>
</template>
